import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
// import Register from './pages/Register'; // Registration temporarily disabled
import Dashboard from './pages/Dashboard';
import ManageAreas from './pages/ManageAreas';
import ManageItems from './pages/ManageItems';
import ManageAreaItems from './pages/ManageAreaItems';
import AdminPanel from './pages/AdminPanel';
import Stocktake from './pages/Stocktake';
import StocktakeReport from './pages/StocktakeReport';
import Header from './components/Header';

const PrivateRoute = ({ children }) => {
  const { token, loading } = useAuth();
  if (loading) {
    return null;
  }
  return token ? children : <Navigate to="/login" />;
};

const HomeRoute = () => {
  const { accountStore, loading, viewMode } = useAuth();

  if (loading) {
    return null;
  }

  if ((accountStore?.role === 'app_admin' || accountStore?.role === 'business_admin') && viewMode !== 'site') {
    return <Navigate to="/admin" replace />;
  }

  return <Dashboard />;
};

const AdminRoute = ({ children }) => {
  const { accountStore, loading } = useAuth();

  if (loading) {
    return null;
  }

  if (!accountStore || (accountStore.role !== 'app_admin' && accountStore.role !== 'business_admin')) {
    return <Navigate to="/" replace />;
  }

  return children;
};

const PublicRoute = ({ children }) => {
  const { token, loading } = useAuth();
  if (loading) {
    return null;
  }
  return token ? <Navigate to="/" /> : children;
};

function AppRoutes() {
  const { token, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="card" style={{ padding: '1.5rem 2rem', textAlign: 'center' }}>
          <div className="spinner" style={{ margin: '0 auto 1rem' }}></div>
          <div>Loading BetterStocktake...</div>
        </div>
      </div>
    );
  }

  return (
    <>
      {token && <Header />}
      <Routes>
        <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
        {/* <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} /> */} {/* Registration temporarily disabled */}
        <Route path="/" element={<PrivateRoute><HomeRoute /></PrivateRoute>} />
        <Route path="/manage-areas" element={<PrivateRoute><ManageAreas /></PrivateRoute>} />
        <Route path="/manage-items" element={<PrivateRoute><ManageItems /></PrivateRoute>} />
        <Route path="/manage-area-items" element={<PrivateRoute><ManageAreaItems /></PrivateRoute>} />
        <Route path="/admin" element={<PrivateRoute><AdminRoute><AdminPanel /></AdminRoute></PrivateRoute>} />
        <Route path="/stocktake/:id" element={<PrivateRoute><Stocktake /></PrivateRoute>} />
        <Route path="/stocktake/:id/report" element={<PrivateRoute><StocktakeReport /></PrivateRoute>} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </Router>
  );
}

export default App;
